module.exports = __webpack_public_path__ + "img/jnd.96bed456.jpg";